import {VesselTag, VesselTagResponse} from '../../../api/vessel-tags'
import {ErrorObject} from './action-creators'

export function formatVesseltagsForUI(vesselTag: VesselTagResponse): VesselTag {
    return {
        identity: vesselTag.tagIdentity,
        name: vesselTag.tagName,
    }
}

export function getTheErrorCodes(errorResult: ErrorObject | undefined): boolean {
    if (!errorResult?.error) {
        return false
    }

    switch (Object.keys(errorResult.error)?.[0]) {
        case '1002':
        case '1004':
        case '1006':
            return true
        default:
            return false
    }
}

export function displayErrorMessage(data?: ErrorObject): string {
    if (!data?.error) {
        return ''
    }

    return data?.error[Object.keys(data?.error)[0]]
}
